import { render, staticRenderFns } from "./form.vue?vue&type=template&id=ae7f7862&"
import script from "./form.ts?vue&type=script&lang=ts&"
export * from "./form.ts?vue&type=script&lang=ts&"
import style0 from "./form.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zhibirc/Work/pets/cut-url-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7f7862')) {
      api.createRecord('ae7f7862', component.options)
    } else {
      api.reload('ae7f7862', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=ae7f7862&", function () {
      api.rerender('ae7f7862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/form.vue"
export default component.exports